import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { Microservices } from "../../../../app/AllowedMicroservices";
import { RootState } from "../../../../app/store";
import apiActionCreator, {
  HttpMethods,
} from "../../../../services/apiActionCreator";
import { FetchStatus } from "../../../common/enums";
import { IFulfillmentPerCompany } from '../common/interfaces';


interface IFulfillmentPerCompanyState {
  courseFulfillmentPerCompany: IFulfillmentPerCompany,
  status: FetchStatus,
}
const initialState: IFulfillmentPerCompanyState = {
  courseFulfillmentPerCompany: {},
  status: FetchStatus.Idle,
};

export const dataSlice = createSlice({
  name: "reportLearningCoursesFulfillmentPerCompany",
  initialState,
  reducers: {
    fetching: (state) => {
      state.status = FetchStatus.Fetching;
    },
    fetched: (state, action: PayloadAction<IFulfillmentPerCompany>) => {
      state.courseFulfillmentPerCompany = action.payload;
      state.status = FetchStatus.Fetched;
    },
    error: (state) => {
      state.status = FetchStatus.Error;
    },
  },
});

export const { fetching, fetched, error } = dataSlice.actions;

export const fetchCoursesCompletionPerCompany = (companyId?: string) => (dispatch: Dispatch<object>) => {
  let url = '/courses/completionPerCompany';
  if(companyId){
    url = `${url}/${companyId}`;
  }
  return dispatch(
    apiActionCreator({
      endpoint: url,
      types: {
        requestType: fetching,
        successTypes: [
          {
            actionOrCreator: fetched,
          },
        ],
        errorTypes: [
          {
            actionOrCreator: error,
          },
        ],
      },
      method: HttpMethods.GET,
      microservice: Microservices.LEARNING_SERVICE,
      authenticated: true,
    })
  );
};

export const selectCoursesFulfillmentsPerCompany = (state: RootState) => state.reports.learning.courses.coursesFulfillmentsPerCompany.courseFulfillmentPerCompany;
export const selectCoursesFulfillmentsPerCompanyFetching = (state: RootState) => state.reports.learning.courses.coursesFulfillmentsPerCompany.status === FetchStatus.Fetching;

export default dataSlice.reducer;
